import PropTypes from 'prop-types'

import * as S from './styled'
import { PhoneIcon } from '../PhoneIcon'
import { WhatsAppIcon } from '../WhatsAppIcon'

const PhoneContent = ({ iconType = 'phone', link, phoneNumber, locale }) => {
  const contacts = {
    whatsapp: {
      name: 'WhatsApp',
      icon: <WhatsAppIcon />
    },
    phone: {
      name: 'Telefone',
      icon: <PhoneIcon />
    }
  }

  const { name, icon } = contacts[iconType]

  const isWhatsApp = () => iconType === 'whatsapp'

  return (
    <S.Wrapper>
      <S.PhoneDescription as="div" size="kilo" noMargin>
        <S.PhoneLink href={link} target={'_blank'} rel="noopener noreferrer">
          {icon}

          <S.ContactType as="span" size="kilo" noMargin>
            {name}:
          </S.ContactType>

          <S.PhoneNumber as="span" size="kilo" noMargin>
            {phoneNumber}
          </S.PhoneNumber>

          <S.Locale as="span" size="kilo" noMargin>
            {locale}
          </S.Locale>

          {isWhatsApp() && <S.Badge color="green">Novo</S.Badge>}
        </S.PhoneLink>
      </S.PhoneDescription>
    </S.Wrapper>
  )
}

PhoneContent.propTypes = {
  iconType: PropTypes.string,
  link: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  locale: PropTypes.string
}

export default PhoneContent
